<template>
  <div class="is-flex is-align-items-center">
    <div v-if="is_populating_recipe" class="loading"></div>
    <select dir="rtl" @input="populateVettingRecipe($event.target.value)">
      <option value="">בחר/י מתכון</option>
      <option v-for="recipe in vetting_recipes" :key="recipe.id" :value="recipe.id">{{ recipe.recipe_name }}</option>
    </select>
  </div>
</template>
<script>
import VettingRecipeHelper from '@/custom/classes/vetting_recipe_helper.js'
export default {
  name: 'vetting-recipe-selector',
  props: ['applicant_id', 'gender', 'certification_date'],
  data () {
    return {
      is_populating_recipe: false,
      vetting_recipe_helper: new VettingRecipeHelper(this.applicant_id),
      vetting_recipes: []
    }
  },
  created () {
    this.$network_utils.getVettingRecipes().then(response => {
      this.vetting_recipes = response
    })
  },
  methods: {
    populateVettingRecipe (recipe_id) {
      if (recipe_id == '') {
        return
      }
      this.is_populating_recipe = true
      let params = {
        recipe_data: this.vetting_recipes.filter(recipe => recipe.id == recipe_id)[0],
        gender: this.gender,
        certification_date: this.certification_date
      }
      this.vetting_recipe_helper.getPopulatedRecipe(params).then(response => {
        this.$emit('input', response)
        this.is_populating_recipe = false
      })
    }
  }
}
</script>
